/**
 * Is the agent's microphone part of the call right now?
 *
 * Not during an automatic voicemail drop: the server plays the recorded
 * message to the prospect's voicemail, the agent's audio is out of the call,
 * and a mute button would do nothing. ProspectDetailPanel hides its call
 * controls when useLiveCallState says pillState === 'voicemail', which it
 * derives from call_status === 'voicemail'. FloatingCallBar applies the same
 * rule through this function:
 *   - with the id of the call on screen: that call is in voicemail;
 *   - without one (the bar between calls, parallel lines ringing): every
 *     active call is in voicemail, so there is no line the agent speaks on.
 */
export interface CallStatusLite {
  id?: string;
  call_status?: string | null;
}

export function isVoicemailDropInProgress(activeCalls: readonly CallStatusLite[] | null | undefined, callId?: string | null): boolean {
  const calls = activeCalls ?? [];
  if (callId) return calls.find((c) => c.id === callId)?.call_status === 'voicemail';
  return calls.length > 0 && calls.every((c) => c.call_status === 'voicemail');
}
